import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState
} from 'react';
import { useStore } from 'react-redux';
import { IndexedDbKeyValueStorageStrategy } from 'record-it-utils/dataStorage/KeyValueStorageStrategy/IndexedDbKeyValueStorageStrategy';
import { config } from '../config';
import { PageLoadingOverlayContext } from '../context/PageLoadingOverlayContext';
import { initI18n } from '../setup/initI18n';
import { initKeyValueStorage } from '../setup/initKeyValueStorage';
import { initStorageAdapter } from '../setup/initStorageAdapter';
import { resetState } from '../store/action/resetState';
import { storeName } from '../store/store';
import { StoreUtils } from '../store/utils/StoreUtils';

export const AppBaseSetup: FunctionComponent = React.memo((props) => {
  const { children } = props;

  const { startLoading, addLoadingMessage } = useContext(
    PageLoadingOverlayContext
  );
  const [initialized, setInitialized] = useState(false);

  const store = useStore();

  useEffect(() => {
    const loadingDisposable = startLoading();

    void (async () => {
      addLoadingMessage('loading configuration');
      await config.load();

      addLoadingMessage('initializing i18n');
      await initI18n();

      addLoadingMessage('initializing KeyValueStorage');
      await initKeyValueStorage(new IndexedDbKeyValueStorageStrategy());

      addLoadingMessage('initializing StorageAdapter');
      initStorageAdapter();

      addLoadingMessage('loading state');
      const state = await StoreUtils.loadState(storeName);
      if (state) {
        store.dispatch(resetState(state));
      }

      // TODO: preload the fonts here (or at least wait for them here) (REC-2164)
      // addLoadingMessage('preloading fonts');

      setInitialized(true);
      loadingDisposable.dispose();
    })();

    return () => {
      setInitialized(false);
      loadingDisposable.dispose();
    };
  }, [startLoading, addLoadingMessage, store]);

  if (!initialized) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
});
